export enum PanDrawerUpgrade {
    NONE = 0,
    HIGH_SIDES = 1,
    FROSTED_SIDES = 2
}
